import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=ba5f0e6a&scoped=true&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"
import style0 from "./summary.vue?vue&type=style&index=0&id=ba5f0e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5f0e6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba5f0e6a')) {
      api.createRecord('ba5f0e6a', component.options)
    } else {
      api.reload('ba5f0e6a', component.options)
    }
    module.hot.accept("./summary.vue?vue&type=template&id=ba5f0e6a&scoped=true&", function () {
      api.rerender('ba5f0e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transaction/summary.vue"
export default component.exports